var map = {
	"./data/mock-posts": "2a70",
	"./data/mock-posts.js": "2a70",
	"./data/mock-projects": "e69b",
	"./data/mock-projects.js": "e69b",
	"./data/mock-updates": "940e",
	"./data/mock-updates.js": "940e",
	"./images/github.png": "90e2",
	"./images/logo.png": "07bc",
	"./images/projects/binary.png": "4d3d",
	"./images/projects/loadbar.jpg": "8701",
	"./images/projects/note_thumbnail.png": "1251",
	"./images/projects/text_thumbnail.png": "0f27",
	"./images/twitter.png": "a891",
	"./images/website_backround.png": "e03f",
	"./images/youtube_icon.png": "c68d",
	"./images/youtube_logo.png": "9e81",
	"./testBlog.txt": "ed4a",
	"./testBlog2.md": "72e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3904";